import { Button, Card, Text } from "@ttc3k/trekker";
import { AssetImage } from "gql/generated";
import { useTranslation } from "react-i18next";
import { Flex } from "styled-system/jsx";
import { css } from "styled-system/css";
import { isLandscape } from "shared/utils";
import { limitFill } from "@cloudinary/transformation-builder-sdk/actions/resize";
import { autoGravity } from "@cloudinary/transformation-builder-sdk/qualifiers/gravity";
import { CloudinaryImage } from "shared/components";
import { ReactNode } from "react";

type ConnectionCardProps = {
  image: AssetImage | null | undefined;
  name: string;
  website?: string | null;
  email?: string | null;
  phone?: string | null;
  ctaOverride?: ReactNode;
};

export const ConnectionCard = ({
  image,
  name,
  email,
  phone,
  website,
  ctaOverride,
}: ConnectionCardProps) => {
  const { t } = useTranslation("core", { keyPrefix: "DOORSTOP" });
  return (
    <Card.Surface bg={"white"}>
      <Card.Body>
        <Card.BodyContent gap={"500"} alignItems={"center"}>
          <Flex gap={"300"} alignItems={"center"}>
            {image && (
              <CloudinaryImage
                image={image}
                imageStyleProps={{
                  borderRadius: "100",
                  objectFit: "scale-down",
                  aspectRatio: "square",
                  className: css({ maxW: "100px", h: "100px" }),
                }}
                resize={
                  isLandscape(image)
                    ? limitFill().height(100).gravity(autoGravity())
                    : limitFill().width(100).gravity(autoGravity())
                }
              />
            )}
            <Flex
              flexDir={"column"}
              gap={"25"}
              pl={image ? "300" : undefined}
              borderLeft={image ? "2px" : undefined}
              borderColor={"border.light"}
              borderStyle={"solid"}
            >
              <Text visual={"bodySemiBold"} color={"text.dark"}>
                {name}
              </Text>
              {(website || email || phone) && (
                <Text visual={"smallMedium"} color={"text.light"}>
                  {website ?? email ?? phone}
                </Text>
              )}
            </Flex>
          </Flex>
          {ctaOverride
            ? ctaOverride
            : (email || phone || website) && (
                <a
                  href={
                    email
                      ? `mailTo:${email}`
                      : phone
                        ? `tel:${phone}`
                        : (website ?? "")
                  }
                >
                  <Button mode={"light"} size={"lg"}>
                    {t("CONNECTIONS.CONTACT")}
                  </Button>
                </a>
              )}
        </Card.BodyContent>
      </Card.Body>
    </Card.Surface>
  );
};
